const initialState = {
    user: null,
    isAuthenticated: false,
    sessionLoading: true,
    error: null,
};

export default function authReducer(state = initialState, action) {
    switch (action.type) {
        case 'RESTORE_SESSION_PENDING':
            return {
                ...state,
                sessionLoading: true,
                error: null,
            };
        case 'RESTORE_SESSION_SUCCESS':
            return {
                ...state,
                user: action.payload.user,
                isAuthenticated: true,
                sessionLoading: false,
                error: null,
            };
        case 'RESTORE_SESSION_FAILURE':
            return {
                ...state,
                user: null,
                isAuthenticated: false,
                sessionLoading: false,
                error: null,
            };
        case 'LOGIN_SUCCESS':
            return {
                ...state,
                user: action.payload.user,
                isAuthenticated: true,
                sessionLoading: false,
                error: null,
            };
        case 'LOGIN_FAILURE':
            return {
                ...state,
                user: null,
                isAuthenticated: false,
                sessionLoading: false,
                error: action.payload,
            };
        case 'LOGOUT':
            return {
                ...state,
                user: null,
                isAuthenticated: false,
                sessionLoading: false,
                error: null,
            };
        case 'UPDATE_USER':
            return {
                ...state,
                user: { ...state.user, ...action.payload },
            };
        default:
            return state;
    }
}
